<template>
  <div class="mb-11">
    <div align="center">
      <!-- ثبت سفارش باز باشه یا بسته///////////////////////////////////// -->
      <div class="link text-light mx-auto" v-if="!expandBox">
        <v-btn
          @click="
            (expandBox = true),
              (notExpand = false),
              checkLoginToOrder(),
              createCart()
          "
          class="
            text-sm-h6
            col-lg-3 col-md-5 col-8
            btn-radio
            blue-bcg
            text-light
            b1
            my-10
            order-btn-h
          "
        >
          <v-icon class="p-3">mdi-cart-plus</v-icon> {{ $t("order") }}
        </v-btn>
      </div>
    </div>
    <div class="container">
      <div class="row">
        <div
          class="col-12 b1 blue-text h4 pointer"
          align="center"
          v-if="expandBox"
          @click="(expandBox = false), (notExpand = true)"
        >
          <v-icon class="p-3 blue-text">mdi-cart-plus</v-icon>
          {{ $t("order") }}
        </div>
      </div>
      <div
        class="row relative"
        :class="{ expandBox: expandBox, notExpand: notExpand }"
      >
        <!-- ///////////////////////////////////فرم کاربر ستون اول//////////////////////////// -->
        <div class="row" v-if="showChooseReciver">
          <div class="col-12 col-md-12 col-lg-6">
            <div class="row b1 h5">{{ $t("orderForm.requierdInfo") }}</div>
            <div class="row">
              <div class="col-6">
                <v-text-field
                  :label="$t('name')"
                  v-model="form.name"
                  :rules="nameRules"
                  hide-details="auto"
                ></v-text-field>
              </div>
              <div class="col-6">
                <v-text-field
                  :label="$t('mobilePhone')"
                  v-model="form.phoneNumber"
                  :rules="phoneNumberRules"
                  hide-details="auto"
                  readonly
                ></v-text-field>
              </div>
            </div>
            <div class="row b1 h5 mb-n5 mt-10">
              {{ $t("orderForm.offerInfo") }}
            </div>
            <div class="row">
              <div class="col-6">
                <v-text-field
                  v-model="form.job"
                  :label="$t('job')"
                  hide-details="auto"
                ></v-text-field>
              </div>
              <div class="col-6">
                <v-text-field
                  v-model="form.univer"
                  :label="$t('univer')"
                  hide-details="auto"
                ></v-text-field>
              </div>
            </div>
            <div class="row">
              <div class="col-6">
                <v-text-field
                  v-model="form.major"
                  :label="$t('major')"
                  hide-details="auto"
                ></v-text-field>
              </div>
              <div class="col-6">
                <v-text-field
                  v-model="form.email"
                  :rules="emailRules"
                  :label="$t('email')"
                  hide-details="auto"
                ></v-text-field>
              </div>
            </div>
          </div>
          <!-- ////////////////////////////////////////////////ستون دوم//////////////////////////////// -->
          <div class="col-12 col-md-12 col-lg-6">
            <div class="row b1 h5">
              <div class="col-8">{{ $t("orderForm.reciverInfo") }}</div>
              <div class="col-4">
                <v-btn
                  v-if="showNewReciverForm"
                  @click="showNewReciverForm = false"
                  small
                  class="blue-border blue-text rounded-pill"
                  >{{ $t("preRecivers") }}</v-btn
                >
                <v-btn
                  v-if="!showNewReciverForm"
                  @click="showNewReciverForm = true"
                  small
                  class="blue-border blue-text rounded-pill"
                  >{{ $t("newReciver") }} +</v-btn
                >
              </div>
            </div>
            <div v-if="showNewReciverForm">
              <div class="row gray-text font14">
                <span>
                  <v-checkbox
                    v-model="reciverIsMe"
                    :label="$t('reciverIsMe')"
                  ></v-checkbox
                ></span>
              </div>
              <div class="row" v-if="!reciverIsMe">
                <div class="col-6">
                  <v-text-field
                    :label="$t('name')"
                    v-model="reciverForm.name"
                    :rules="nameRules"
                    hide-details="auto"
                  ></v-text-field>
                </div>
                <div class="col-6">
                  <v-text-field
                    :label="$t('mobilePhone')"
                    v-model="reciverForm.phoneNumber"
                    :rules="phoneNumberRules"
                    hide-details="auto"
                  ></v-text-field>
                </div>
              </div>
              <div class="row">
                <v-radio-group v-model="tehran" mandatory>
                  <v-radio :label="$t('inTehran')" value="inTehran"></v-radio>
                  <v-radio :label="$t('notTehran')" value="notTehran"></v-radio>
                </v-radio-group>
              </div>
              <div class="row" v-if="tehran == 'notTehran'">
                <div class="col-6">
                  <v-text-field
                    v-model="reciverForm.state"
                    :label="$t('state')"
                    hide-details="state"
                  ></v-text-field>
                </div>
                <div class="col-6">
                  <v-text-field
                    v-model="reciverForm.city"
                    :label="$t('city')"
                    hide-details="auto"
                  ></v-text-field>
                </div>
              </div>

              <div class="row mt-n5">
                <div class="col-12">
                  <v-text-field
                    v-model="reciverForm.address"
                    :label="$t('exactAddres')"
                  >
                  </v-text-field>
                </div>
              </div>

              <div class="row mt-n10">
                <div class="col-6">
                  <div class="row">
                    <div class="col-6">
                      <v-text-field
                        :label="$t('plaque')"
                        maxlength="4"
                        v-model="reciverForm.plaqe"
                      ></v-text-field>
                    </div>
                    <div class="col-6">
                      <v-text-field
                        :label="$t('unit')"
                        v-model="reciverForm.unit"
                      ></v-text-field>
                    </div>
                  </div>
                </div>
                <div class="col-6">
                  <div class="row">
                    <div class="col-12">
                      <v-text-field
                        :label="$t('postCode')"
                        v-model="reciverForm.postalcode"
                        maxlength="10"
                      ></v-text-field>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!-- ////////////////////انتخاب دریافت کننده//////////////////// -->
            <div v-if="!showNewReciverForm">
              <div v-for="reciver in recivers" :key="reciver.id">
                <v-radio-group v-model="choosenReciver">
                  <label :for="reciver.id" class="row blue-border p-1 pointer">
                    <div class="row">
                      <v-radio :value="reciver.id" :id="reciver.id"></v-radio>
                    </div>
                    <div class="col-4 font-14" align="right" dir="rtl">
                      <v-icon>mdi-account-outline</v-icon>{{ reciver.name }}
                    </div>
                    <div class="col-8 p-6 font-14" align="right" dir="rtl">
                      <v-icon>mdi-phone</v-icon> {{ reciver.phone_number }}
                    </div>

                    <div
                      class="col-12 scrollX font-14 mt-n3"
                      align="right"
                      dir="rtl"
                    >
                      <v-icon>mdi-map-marker</v-icon>{{ reciver.ostan }}
                      {{ reciver.shahr }} {{ reciver.address }} کد پستی
                      {{ reciver.code }}
                    </div>
                  </label>
                </v-radio-group>
              </div>
            </div>
          </div>
        </div>
        <br />

        <div v-if="showChooseFile">
          <div class="col-12">
            <div class="row">
              <div class="col-12 col-lg-1 b1 h4 mt-lg-n2 mt-n4">
                {{ $t("orderForm.atention") }}
              </div>
              <div class="col-12 col-lg-3 font14">
                <v-icon>mdi-pin</v-icon>{{ $t("orderForm.notic1") }}
              </div>
              <div class="col-12 col-lg-4 font14">
                <v-icon>mdi-pin</v-icon> {{ $t("orderForm.notic2") }}
              </div>
              <div class="col-12 col-lg-4 font14">
                <v-icon>mdi-pin</v-icon> {{ $t("orderForm.notic3") }}
              </div>
            </div>
          </div>
          <!-- <div class="row mr-n7">
            <router-link to="/guid" class="link col-12 col-lg-3"
              ><div align="center" class="col-12 rounded-pill gray-bcg">
                <v-icon>mdi-printer</v-icon> {{ $t("guid") }}
              </div></router-link
            >
          </div> -->
          <div class="row">
            <!-- /////////////////////////////////////////////انتخاب فایل/////////////////////////////////// -->
            <div class="col-12 col-lg-6">
              <div class="row">
                <div class="col-5 col-lg-3 mr-n2">
                  <label for="file-upload" class="active fileInp btn">
                    {{ $t("orderForm.chooseFile") }}
                  </label>
                </div>
                <div
                  class="
                    col-12 col-lg-9
                    border-dark
                    b1
                    rounded-pill
                    font14
                    mr-3
                    deActive1
                    my-3
                  "
                  v-show="showFileInp"
                >
                  <v-file-input
                    id="file-upload"
                    accept="application/pdf"
                    name="userfile"
                    type="file"
                    class="showFileName"
                    @change="showFileInp = true"
                    v-model="orderInfo.file"
                    show-size
                    small-chips
                  ></v-file-input>
                </div>
              </div>
              <!-- //////////////////////////////////////////سایز صفحه///////////////////////////////-->
              <div class="row font14 b1">{{ $t("orderForm.size") }}</div>
              <div class="row">
                <!-- <div
              class="col-3 m-1 deActive1 pointer"
              :class="{
                active: orderInfo.size.A5,
              }"
              @click="
                (orderInfo.size.A4 = false),
                  (orderInfo.size.A5 = true),
                  (orderInfo.size.size = 'A5')
              "
            >
              {{ $t("orderForm.A5") }}
            </div> -->
                <div
                  class="col-4 col-lg-3 m-1 deActive1 pointer"
                  :class="{
                    active: orderInfo.size.A4,
                  }"
                  @click="
                    (orderInfo.size.A4 = true),
                      (orderInfo.size.A5 = false),
                      (orderInfo.size.size = 'orderForm.A4')
                  "
                >
                  {{ $t("orderForm.A4") }}
                </div>
              </div>
              <!-- //////////////////////////////////////////صحافی  /////////////؟ /////////////////////-->
              <div class="row font14 b1">
                {{ $t("orderForm.bookbindingType") }}
              </div>
              <div class="row">
                <div
                  class="col-5 col-lg-3 m-1 deActive1 pointer"
                  :class="{
                    active: orderInfo.bookbindingType.none,
                  }"
                  @click="
                    (orderInfo.bookbindingType.none = true),
                      (orderInfo.bookbindingType.punch = false),
                      (orderInfo.bookbindingType.bookbinding = false),
                      (orderInfo.bookbindingType.bookbindingType = 'N')
                  "
                >
                  {{ $t("orderForm.none") }}
                </div>
                <div
                  class="col-3 m-1 deActive1 pointer"
                  :class="{
                    active: orderInfo.bookbindingType.punch,
                  }"
                  @click="
                    (orderInfo.bookbindingType.none = false),
                      (orderInfo.bookbindingType.punch = true),
                      (orderInfo.bookbindingType.bookbinding = false),
                      (orderInfo.bookbindingType.bookbindingType = 'M')
                  "
                >
                  {{ $t("orderForm.punch") }}
                </div>
                <div
                  class="col-3 m-lg-1 mt-1 deActive1 pointer"
                  :class="{
                    active: orderInfo.bookbindingType.bookbinding,
                  }"
                  @click="
                    (orderInfo.bookbindingType.none = false),
                      (orderInfo.bookbindingType.punch = false),
                      (orderInfo.bookbindingType.bookbinding = true),
                      (orderInfo.bookbindingType.bookbindingType = 'S')
                  "
                >
                  {{ $t("orderForm.bookbinding") }}
                </div>
              </div>
            </div>
            <div class="col-12 col-lg-6">
              <!-- ///////////////////////تعداد سری//////////////////////////////////////////////////////////////////// -->
              <div class="row font14 b1 mr-1">{{ $t("orderForm.series") }}</div>
              <div class="row">
                <div class="col-12 col-lg-6">
                  <div class="row">
                    <div
                      class="col-2 pointer deActive m-1"
                      :class="{
                        active: orderInfo.series.isActiveOne,
                      }"
                      @click="
                        (orderInfo.series.isActiveOne = true),
                          (orderInfo.series.isActiveTwo = false),
                          (orderInfo.series.isActiveThree = false),
                          (orderInfo.series.isActiveOther = false),
                          (orderInfo.series.showInp = false),
                          (orderInfo.series.series = 1)
                      "
                    >
                      1
                    </div>
                    <div
                      class="col-2 pointer deActive m-1"
                      :class="{
                        active: orderInfo.series.isActiveTwo,
                      }"
                      @click="
                        (orderInfo.series.isActiveTwo = true),
                          (orderInfo.series.isActiveOne = false),
                          (orderInfo.series.isActiveThree = false),
                          (orderInfo.series.isActiveOther = false),
                          (orderInfo.series.showInp = false),
                          (orderInfo.series.series = 2)
                      "
                    >
                      2
                    </div>
                    <div
                      class="col-2 pointer deActive m-1"
                      :class="{
                        active: orderInfo.series.isActiveThree,
                      }"
                      @click="
                        (orderInfo.series.isActiveThree = true),
                          (orderInfo.series.isActiveTwo = false),
                          (orderInfo.series.isActiveOne = false),
                          (orderInfo.series.isActiveOther = false),
                          (orderInfo.series.showInp = false),
                          (orderInfo.series.series = 3)
                      "
                    >
                      3
                    </div>

                    <div
                      class="col-2 pointer deActive others m-1"
                      :class="{
                        active: orderInfo.series.isActiveOther,
                      }"
                      @click="
                        (orderInfo.series.isActiveOther = true),
                          (orderInfo.series.isActiveThree = false),
                          (orderInfo.series.isActiveTwo = false),
                          (orderInfo.series.isActiveOne = false),
                          (orderInfo.series.showInp = true)(
                            (orderInfo.series.series = 1)
                          )
                      "
                    >
                      {{ $t("others") }}
                    </div>
                    <div class="col-1 mt-n2">
                      <input
                        class="seriesInp border"
                        v-if="orderInfo.series.showInp"
                        v-model="orderInfo.series.series"
                        type="number"
                        min="1"
                        step="1"
                      />
                    </div>
                  </div>
                </div>
              </div>
              <!-- ////////////////////////////////نوع چاپ//////////////////////////////////// -->
              <div class="row font14 b1 mr-1">
                {{ $t("orderForm.colorType") }}
              </div>
              <div class="row">
                <div
                  class="col-6 col-lg-4 m-1 deActive1 pointer small"
                  :class="{
                    active: orderInfo.colorType.isActiveFirst,
                  }"
                  @click="
                    (orderInfo.colorType.isActiveFirst = true),
                      (orderInfo.colorType.isActiveSecond = false),
                      (orderInfo.colorType.isActiveThird = false),
                      (orderInfo.colorType.isActiveFourth = false),
                      (orderInfo.colorType.colorType = 'BW2'),
                      (showSlideOption = true)
                  "
                >
                  {{ $t("both-black-white") }}
                </div>

                <div
                  class="col-5 col-lg-3 m-1 deActive1 pointer small"
                  :class="{
                    active: orderInfo.colorType.isActiveFourth,
                  }"
                  @click="
                    (orderInfo.colorType.isActiveFirst = false),
                      (orderInfo.colorType.isActiveSecond = false),
                      (orderInfo.colorType.isActiveThird = false),
                      (orderInfo.colorType.isActiveFourth = true),
                      (orderInfo.colorType.colorType = 'RGB2'),
                      (showSlideOption = true)
                  "
                >
                  {{ $t("both-colorfull") }}
                </div>
              </div>
              <div class="row">
                <div
                  class="col-6 col-lg-4 m-1 deActive1 pointer small"
                  :class="{
                    active: orderInfo.colorType.isActiveThird,
                  }"
                  @click="
                    (orderInfo.colorType.isActiveFirst = false),
                      (orderInfo.colorType.isActiveSecond = false),
                      (orderInfo.colorType.isActiveThird = true),
                      (orderInfo.colorType.isActiveFourth = false),
                      (orderInfo.colorType.colorType = 'BW1'),
                      (showSlideOption = false)
                  "
                >
                  {{ $t("black-white") }}
                </div>
                <div
                  class="col-5 col-lg-3 m-1 deActive1 pointer small"
                  :class="{
                    active: orderInfo.colorType.isActiveSecond,
                  }"
                  @click="
                    (orderInfo.colorType.isActiveFirst = false),
                      (orderInfo.colorType.isActiveSecond = true),
                      (orderInfo.colorType.isActiveThird = false),
                      (orderInfo.colorType.isActiveFourth = false),
                      (orderInfo.colorType.colorType = 'RGB1'),
                      (showSlideOption = false)
                  "
                >
                  {{ $t("colorfull") }}
                </div>
              </div>
            </div>
          </div>
          <!-- ////////////////////////////////// باکس چک ////////////////////////// -->
          <div class="row gray-text font14">
            <div class="col-11 col-lg-8">
              <v-row v-if="showSlideOption" align="center">
                <div class="row">
                  <div class="col-12 col-md-8 col-lg-6">
                    <v-checkbox
                      :label="$t('slide')"
                      v-model="slide"
                      @click="clearSelectBox()"
                      hide-details
                      class="shrink mr-2 mt-0"
                    ></v-checkbox>
                  </div>
                </div>
                <div class="row">
                  <div class="col-12 col-md-8 col-lg-6">
                    <v-select
                    dense
                      item-value="id"
                      item-text="value"
                      v-model="slidingVal"
                      :items="sliding"
                      :disabled="!slide"
                      :label="$t('chooseSlideMode')"
                      outlined
                    ></v-select>
                  </div>
                </div>
              </v-row>
            </div>
          </div>
          <div class="row gray-text font14 mt-n10">
            <div class="col-12 col-lg-3">
              <span>
                <v-checkbox
                  v-model="chaapchiRules"
                  :label="$t('orderForm.rules')"
                ></v-checkbox
              ></span>
            </div>
          </div>
          <!-- /////////////////////////////////افزودن به کارت///////////////////////////////////// -->
          <div class="row">
            <div class="col-lg-3 col-12 p-2" align="center">
              <div
                class="rounded-pill active pointer p-2"
                @click="addToCard()"
                :class="{ disable: loading, pointer: !loading }"
              >
                {{ $t("orderForm.addToCard") }}
                <v-icon class="text-light m-1" v-if="!loading">mdi-send</v-icon>
                <span
                  v-if="loading"
                  class="spinner-border spinner-border-sm text-light"
                  role="status"
                >
                  <!-- <span class="sr-only"></span> -->
                </span>
              </div>
              <v-progress-linear
                v-if="loading"
                class="mt-4"
                indeterminate
                reverse
              ></v-progress-linear>
            </div>
          </div>
        </div>
        <!-- ///////////////////////////////سبد ///////////////// -->
        <Card v-if="goToCard" :key="componentKey" />
        <Factor v-if="goToFactor" :key="componentKey" />

        <div class="row">
          <div class="col-10">
            <v-btn
              v-if="showChooseFile"
              class="pay rounded-pill b1"
              @click="
                (goToCard = false),
                  (showChooseFile = false),
                  showNewReciverFormDicide(),
                  (showChooseReciver = true),
                  scrolltop()
              "
              dark
              ><v-icon class="m-1">mdi-map-marker</v-icon
              >{{ $t("chooseAddress") }}
            </v-btn>
          </div>

          <div class="col-10">
            <v-btn
              v-if="!showChooseFile"
              class="rounded-pill b1"
              @click="
                scrolltop(),
                  (goToCard = true),
                  (showChooseFile = true),
                  (showChooseReciver = false),
                  (goToFactor = false)
              "
              dark
              >&lsaquo; {{ $t("back") }}
            </v-btn>
          </div>
          <div class="col-10" v-if="!goToCard && !goToFactor">
            <v-btn
              class="rounded-pill b1 blue-bcg"
              @click="chooseReciver()"
              dark
            >
              {{ $t("payCard") }} &rsaquo;
            </v-btn>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import router from "../../router";
import Card from "./Card.vue";
import Factor from "./factor.vue";
export default {
  components: {
    Card,
    Factor,
  },
  data() {
    return {
      slidingVal: "",
      sliding: [
        { id: "true", value: this.$t("rtl") },
        { id: "trueLTR", value: this.$t("ltr") },
        { id: "trueVertical", value: this.$t("shortEdge") },
      ],

      showSlideOption: true,
      loading: false,
      goToFactor: false,
      showPayPrice: false,
      componentKey: 0,
      recivers: [],
      choosenReciver: "",
      notExpand: true,
      expandBox: false,
      showChooseReciver: false,
      showChooseFile: true,
      goToCard: true,
      tehran: "inThran",
      reciverIsMe: false,
      showNewReciverForm: false,
      showFileInp: false,
      chaapchiRules: false,
      slide: false,
      orderInfo: {
        file: [],
        series: {
          isActiveOne: true,
          isActiveTwo: false,
          isActiveThree: false,
          isActiveOther: false,
          series: 1,
        },
        colorType: {
          isActiveFirst: true,
          isActiveSecond: false,
          isActiveThird: false,
          isActiveFourth: false,
          colorType: "BW2",
        },
        size: {
          A5: false,
          A4: true,
          size: "A4",
        },

        // twoInOne: false,
        bookbindingType: {
          none: true,
          punch: "",
          bookbinding: "",
          bookbindingType: "N",
        },
      },

      form: {
        phoneNumber: "",
        name: "",
        job: "",
        univer: "",
        major: "",
        email: "",
      },
      reciverForm: {
        phoneNumber: "",
        name: "",
        state: "",
        city: "",
        address: "",
        plaqe: "",
        unit: "",
        postalcode: "",
      },
      phoneNumberRules: [
        (v) => !!v || this.$t("phoneNumberRequierd"),
        (v) => v.length == 11 || this.$t("wrongPhone"),
      ],
      nameRules: [(v) => !!v || this.$t("nameRquierd")],
      emailRules: [(v) => /.+@.+/.test(v) || this.$t("wrongEmail")],
    };
  },
  methods: {
    clearSelectBox() {
      if (!this.slide) {
        this.slidingVal = "";
      } else {
        this.slidingVal = "true";
      }
    },
    showNewReciverFormDicide() {
      if (this.recivers.length > 0) {
        this.showNewReciverForm = false;
      } else {
        this.showNewReciverForm = true;
      }
    },
    chooseReciver() {
      var formInfo = {
        first_name: this.form.name,
        last_name: " ",
        field_of_study: this.form.major,
        university: this.form.univer,
        carry: this.form.job,
        email: this.form.email,
      };
      this.axios.defaults.headers.common["Authorization"] =
        "Bearer " + this.$session.get("token");
      this.axios.put("account/info/" + this.$session.get("pk") + "/", formInfo);
      if (!this.showNewReciverForm) {
        if (this.choosenReciver) {
          this.axios.defaults.headers.common["Authorization"] =
            "Bearer " + this.$session.get("token");
          var reciverId = { id: this.choosenReciver };
          this.axios
            .post(this.$session.get("newCartid") + "/transferee", reciverId)
            .then((response) => {
              console.log(response);
              this.componentKey += 1;
              this.goToCard = false;
              this.goToFactor = true;
              this.scrolltop();
              this.showChooseFile = false;
              this.showNewReciverForm = false;
              this.showChooseReciver = false;
              this.showPayPrice = true;
            });
        } else {
          this.$noty.info(this.$t("noAddress"));
        }
      } else {
        if (this.tehran == "inTehran") {
          this.reciverForm.state = this.$t("Tehran");
          this.reciverForm.city = this.$t("Tehran");
        }
        if (this.reciverIsMe) {
          this.reciverForm.name = this.form.name;
          this.reciverForm.phoneNumber = this.form.phoneNumber;
        }
        var newReciverForm = {
          name: this.reciverForm.name,
          address:
            this.$t("address:") +
            this.reciverForm.address +
            "  " +
            this.$t("plaque:") +
            this.reciverForm.plaqe +
            "  " +
            this.$t("unit:") +
            this.reciverForm.unit,
          code: this.reciverForm.postalcode,
          shahr: this.reciverForm.city,
          ostan: this.reciverForm.state,
          phone_number: this.reciverForm.phoneNumber,
        };
        this.axios.defaults.headers.common["Authorization"] =
          "Bearer " + this.$session.get("token");
        if (
          this.reciverForm.plaqe &&
          this.reciverForm.address &&
          this.reciverForm.postalcode &&
          this.reciverForm.unit
        ) {
          this.axios
            .post("transferee/", newReciverForm)
            .then((response) => {
              console.log(response);
              var newResiverId = { id: response.data[0].id };
              this.axios
                .post(
                  this.$session.get("newCartid") + "/transferee",
                  newResiverId
                )
                .then((response) => {
                  console.log(response);
                  this.componentKey += 1;
                  this.goToCard = false;
                  this.goToFactor = true;
                  this.scrolltop();
                  this.showChooseFile = false;
                  this.showNewReciverForm = false;
                  this.showChooseReciver = false;
                  this.showPayPrice = true;
                  this.axios.defaults.headers.common["Authorization"] =
                    "Bearer " + this.$session.get("token");
                  this.axios.get("transferee").then((response) => {
                    console.log(response.data[0]);
                    this.recivers = response.data[0];
                  });
                });
            })
            .catch((error) => {
              console.log(error.response.data[0]);
              this.$noty.error(this.$t("enterName"));
            });
        } else {
          this.$noty.error(this.$t("completeTheAddress"));
        }
      }
    },
    addToCard() {
      if (this.chaapchiRules) {
        this.loading = true;
        this.axios.defaults.headers.common["Authorization"] =
          "Bearer " + this.$session.get("token");
        this.axios
          .post("cart/")
          .then((response) => {
            console.log(response.data[0]);
            // this.$session.set("newCartid", response.data[0]);
          })
          .catch((error) => {
            console.log(error);
          });
        var formData = new FormData();
        var file = document.querySelector("#file-upload");

        formData.append("file", file.files[0]);
        formData.append("size", this.orderInfo.size.size);
        formData.append(
          "bookbinding",
          this.orderInfo.bookbindingType.bookbindingType
        );
        formData.append("type", this.orderInfo.colorType.colorType);
        formData.append("print_number", this.orderInfo.series.series);
        if (this.showSlideOption && this.slide) {
          formData.append("slide", this.slidingVal);
        }
        formData.append("cart", Number(this.$session.get("newCartid")));
        this.axios.defaults.headers.common["Authorization"] =
          "Bearer " + this.$session.get("token");
        if (file.files.length > 0) {
          this.axios
            .post("order/?cart=" + this.$session.get("newCartid"), formData, {
              headers: {
                "Content-Type": "multipart/form-data",
              },
            })
            .then((response) => {
              console.log(response);
              this.componentKey += 1;
              this.orderInfo.file = [];
              file.value = "";

              this.slide = false;
              this.showSlideOption = true;

              this.showFileInp = false;
              this.orderInfo.series.isActiveOne = true;
              this.orderInfo.series.isActiveTwo = false;
              this.orderInfo.series.isActiveThree = false;
              this.orderInfo.series.isActiveOther = false;
              this.orderInfo.series.series = 1;

              this.orderInfo.colorType.isActiveFirst = true;
              this.orderInfo.colorType.isActiveSecond = false;
              this.orderInfo.colorType.isActiveThird = false;
              this.orderInfo.colorType.isActiveFourth = false;
              this.orderInfo.colorType.colorType = "BW2";

              this.orderInfo.bookbindingType.none = true;
              this.orderInfo.bookbindingType.punch = "";
              this.orderInfo.bookbindingType.bookbinding = "";
              this.orderInfo.bookbindingType.bookbindingType = "N";
              this.loading = false;
              this.slidingVal = "";
            })
            .catch((error) => {
              this.loading = false;
              this.$noty.error(error.response.data[0]);
              console.log(error.response.data[0]);
            });
        } else {
          this.$noty.info(this.$t("noFile"));
          this.loading = false;
        }
      } else {
        this.$noty.info(this.$t("acceptRules"));
      }
    },
    scrolltop() {
      window.scrollTo(0, 100);
    },
    checkLoginToOrder() {
      if (this.$session.get("login")) {
        console.log(this.$session.get("login"));
      } else {
        this.expandBox = false;
        this.notExpand = true;
        this.$noty.info(this.$t("onlyLogin"));
        router.push("/sign");
      }
    },
    createCart() {
      this.axios.defaults.headers.common["Authorization"] =
        "Bearer " + this.$session.get("token");
      this.axios
        .post("cart/")
        .then((response) => {
          console.log(response.data[0]);
          this.$session.set("newCartid", response.data[0]);
          this.componentKey += 1;
          console.log(Number(this.$session.get("newCartid")));
          this.componentKey += 1;
          if (this.$router.history.current.path == "/panelNewOrder") {
            this.expandBox = true;
            this.notExpand = false;
          }
          this.axios.defaults.headers.common["Authorization"] =
            "Bearer " + this.$session.get("token");
          this.axios.get("transferee").then((response) => {
            console.log(response.data[0]);
            this.recivers = response.data[0];
          });
          this.axios.get("account/pk").then((response) => {
            console.log(response.data[0].pk);
            this.$session.set("pk", response.data[0].pk);
            this.axios
              .get("account/info/" + response.data[0].pk + "/ ")
              .then((response) => {
                console.log(response.data);
                this.form.phoneNumber = response.data.phone_number;
                this.form.major = response.data.field_of_study;
                this.form.univer = response.data.university;
                this.form.email = response.data.email;
                this.form.job = response.data.carry;
                this.form.name = response.data.first_name;
              });
          });
        })
        .catch((error) => {
          console.log(error);
        });
    },
  },
  mounted() {
    if (
      this.$session.get("token") &&
      this.$router.history.current.path == "/panelNewOrder"
    ) {
      this.axios.defaults.headers.common["Authorization"] =
        "Bearer " + this.$session.get("token");
      this.axios
        .post("cart/")
        .then((response) => {
          console.log(response.data[0]);
          this.$session.set("newCartid", response.data[0]);
          this.componentKey += 1;
          console.log(Number(this.$session.get("newCartid")));
          this.componentKey += 1;
          if (this.$router.history.current.path == "/panelNewOrder") {
            this.expandBox = true;
            this.notExpand = false;
          }
          this.axios.defaults.headers.common["Authorization"] =
            "Bearer " + this.$session.get("token");
          this.axios.get("transferee").then((response) => {
            console.log(response.data[0]);
            this.recivers = response.data[0];
          });
          this.axios.get("account/pk").then((response) => {
            console.log(response.data[0].pk);
            this.$session.set("pk", response.data[0].pk);
            this.axios
              .get("account/info/" + response.data[0].pk + "/ ")
              .then((response) => {
                console.log(response.data);
                this.form.phoneNumber = response.data.phone_number;
                this.form.major = response.data.field_of_study;
                this.form.univer = response.data.university;
                this.form.email = response.data.email;
                this.form.job = response.data.carry;
                this.form.name = response.data.first_name;
              });
          });
        })
        .catch((error) => {
          console.log(error);
        });
    }
  },
};
</script>
<style scoped>
.showFileName {
  height: 0em;
  margin-top: -1.5em;
}
.fileInp {
  width: 130px;
  border-radius: 30px;
}
.seriesInp {
  width: 100px;
  height: 35px;
  border-radius: 10px;
  padding: 1em;
}
.active {
  background-color: #3c56c8 !important;
  color: #fff !important;
}
.deActive {
  color: #575757;
  border: 1px solid #575757;
  border-radius: 100%;
  text-align: center;
  width: 35px;
  height: 35px;
  line-height: 70%;
}
.deActive1 {
  color: #575757;
  border: 1px solid #575757;
  border-radius: 18px;
  text-align: center;
  height: 35px;
  line-height: 70%;
}
.others {
  width: 55px;
  border-radius: 18px;
}
.order-btn-h {
  height: 3em !important;
}
.expandBox {
  transition: 0.5s;
  border-radius: 10px;
  border: solid 3px #3c56c8;
  padding: 1.5em;
  background-color: #fff;
  overflow: hidden;
}
.notExpand {
  height: 0vh;
  overflow: hidden;
  width: 25%;
  transition: 1s;
}
.radius {
  border-radius: 18px !important;
}
.pay {
  background-color: #20db6b !important;
}
</style>
